import { render } from "./ProjectPage.vue?vue&type=template&id=a972a308&scoped=true&ts=true"
import script from "./ProjectPage.vue?vue&type=script&lang=ts"
export * from "./ProjectPage.vue?vue&type=script&lang=ts"

import "./ProjectPage.vue?vue&type=style&index=0&id=a972a308&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a972a308"]])

export default __exports__